/* eslint-disable no-undef */
/* global filter_obj */
const $ = jQuery.noConflict();

/* ------------------------------ Script on ready ------------------------------ */
$(document).ready(function() {
    if ($('.lg-filter').length) {
        const $filterCols = $('.lg-filter-col');
        const $filterMenus = $('.lg-filter-menu');
        $('.lg-filter-col .lg-filter-item').on('click', function() {
            const $parentCol = $(this).parent();
            $filterCols.not($parentCol).removeClass('active');
            $filterMenus.not($(this).next()).stop().slideUp();
            if ($parentCol.hasClass('active')) {
                $(this).next('.lg-filter-menu').stop().slideUp();
                $parentCol.stop().removeClass('active');
            } else {
                $(this).next('.lg-filter-menu').stop().slideDown();
                $parentCol.stop().addClass('active');
            }
        });
        $('.lg-search').on('click', function() {
            $filterCols.removeClass('active');
            $filterMenus.stop().slideUp();
        });
        $(document).on('click touchstart', function(e) {
            const $target = $(e.target);
            if (!$target.closest('.lg-filter-col').length && !$target.closest('.lg-search').length) {
                $filterCols.removeClass('active');
                $filterMenus.stop().slideUp();
            }
        });
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                $filterCols.removeClass('active');
                $filterMenus.stop().slideUp();
            }
        });
    }

    /************* Event FILTER - START *****************/
    $('.post-ajax-filter form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();
        let region = [];
        let solution = [];
        let type = [];
        let channel = [];

        $('.post-ajax-filter .lg-filter-selected-list').empty();

        $('.post-ajax-filter form.listing-filter-form input[name="channel"]:checked').each(function() {
            channel.push($(this).val());
            const channel_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append('<button class="lg-selected channel-selected no-btn" data-slug="channel_' + $(this).val() + '"><em class="close-icon"></em>' + channel_label + '</button>');
        });
        $('.post-ajax-filter form.listing-filter-form input[name="region"]:checked').each(function() {
            region.push($(this).val());
            const region_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append('<button class="lg-selected region-selected no-btn" data-slug="region_' + $(this).val() + '"><em class="close-icon"></em>' + region_label + '</button>');
        });
        $('.post-ajax-filter form.listing-filter-form input[name="solution"]:checked').each(function() {
            solution.push($(this).val());
            const solution_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append('<button class="lg-selected solution-selected no-btn" data-slug="solution_' + $(this).val() + '"><em class="close-icon"></em>' + solution_label + '</button>');
        });

        $('.post-ajax-filter form.listing-filter-form input[name="type"]:checked').each(function() {
            type.push($(this).val());
            const type_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
            $('.lg-filter-selected-list').append('<button class="lg-selected type-selected no-btn" data-slug="type_' + $(this).val() + '"><em class="close-icon"></em>' + type_label + '</button>');
        });

        const pager = $('.post-ajax-filter form.listing-filter-form #pager').val();
        const posts_per_page = $('.post-ajax-filter form.listing-filter-form input[name="posts_per_page"]').val();
        const search_keyword = $('.post-ajax-filter form.listing-filter-form input[name="search_text"]').val();
        const lg_type_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_type_select"]').val();
        const lg_solution_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_solution_select"]').val();
        const lg_region_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_region_select"]').val();
        const lg_channel_select = $('.post-ajax-filter form.listing-filter-form input[name="lg_channel_select"]').val();
        const sort_value = $('.post-ajax-filter form.listing-filter-form .filter-order').val();

        // Get selected filters as comma-separated strings
        solution = $('.post-ajax-filter form.listing-filter-form input[name="solution"]:checked')
            .map(function() {
                return this.value;
            }).get().join(',');

        region = $('.post-ajax-filter form.listing-filter-form input[name="region"]:checked')
            .map(function() {
                return this.value;
            }).get().join(',');

        type = $('.post-ajax-filter form.listing-filter-form input[name="type"]:checked')
            .map(function() {
                return this.value;
            }).get().join(',');
        channel = $('.post-ajax-filter form.listing-filter-form input[name="channel"]:checked')
            .map(function() {
                return this.value;
            }).get().join(',');
        //  modify_post_filter_url(pager, search_keyword, sort_value, region, solution, type, channel);
        post_filter_data(pager, posts_per_page, search_keyword, sort_value, region, lg_region_select, solution, lg_solution_select, type, lg_type_select, channel, lg_channel_select);
    });
});

$(document).on('change keydown', '.search-text', function(e) {
    $('.post-ajax-filter #pager').val(1);
});

$(document).on('click', '.post-ajax-filter .icon-search-2', function(e) {
    e.preventDefault();
    $('.post-ajax-filter #pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});


$(document).on('click', '.lg-filter-selected-list .lg-selected', function() {
    const fid = $(this).data('slug');
    $('.post-ajax-filter #' + fid).prop('checked', false);
    $(this).remove();
    $('.post-ajax-filter #pager').val(1);
    $('.listing-filter-form').submit();
});

// Pagination next link
$(document).on('click', '.post-ajax-filter form.listing-filter-form .pagination a.next', function(event) {
    event.preventDefault();
    const pager = $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val();
    const max_pages = $('.post-ajax-filter form.listing-filter-form input[name="max_pages"]').val();
    if (+pager <= +max_pages) {
        // $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val(+pager + 1);
        $('.post-ajax-filter form.listing-filter-form #pager').val(+pager + 1);
        $('.post-ajax-filter form.listing-filter-form').submit();
    }
});

// Pagination prev link
$(document).on('click', '.post-ajax-filter form.listing-filter-form .pagination a.prev', function(event) {
    event.preventDefault();
    const pager = $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val();
    if (+pager >= 1) {
        // $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val(+pager - 1);
        $('.post-ajax-filter form.listing-filter-form #pager').val(+pager - 1);
        $('.post-ajax-filter form.listing-filter-form').submit();
    }
});


$(document).ready(function($) {
    // Handle "All Content Types" checkbox
    // $('.post-ajax-filter #solution-all').on('change', function() {
    //     if ($(this).is(':checked')) {
    //         $('input[name="solution"]').prop('checked', true); // Check all checkboxes with name="solution"
    //     } else {
    //         $('input[name="solution"]').prop('checked', false); // Uncheck all checkboxes with name="solution"
    //     }
    // });

    // // Handle individual checkboxes with name="solution"
    // $('.post-ajax-filter input[name="solution"]').on('change', function() {
    //     const allChecked = $('input[name="solution"]:checked').length === $('input[name="solution"]').length;
    //     $('#solution-all').prop('checked', allChecked); // Sync "All solution" checkbox
    // });

    // // Uncheck All if removed from selected list
    // $(document).on('click', '.post-ajax-filter .solution-selected', function() {
    //     $('#solution-all').prop('checked', false); // Sync "All solution" checkbox
    // });

    // const allTopicChecked = $('input[name="solution"]').length === $('input[name="solution"]:checked').length;
    // $('.post-ajax-filter #solution-all').prop('checked', allTopicChecked);

    // $(document).on('click', '.post-ajax-filter .lg-filter-solution-reset', function() {
    //     $('#solution-all').prop('checked', false); // Sync "All solution" checkbox
    //     $('input[name="solution"]').prop('checked', false); // Uncheck all checkboxes with name="solution"
    //     $('.listing-filter-form').submit();
    // });

    // $('.post-ajax-filter #region-all').on('change', function() {
    //     if ($(this).is(':checked')) {
    //         $('input[name="region"]').prop('checked', true); // Check all checkboxes with name="solution"
    //     } else {
    //         $('input[name="region"]').prop('checked', false); // Uncheck all checkboxes with name="solution"
    //     }
    // });

    // // Handle individual checkboxes with name="region"
    // $('.post-ajax-filter input[name="region"]').on('change', function() {
    //     const allChecked = $('input[name="region"]:checked').length === $('input[name="region"]').length;
    //     $('#region-all').prop('checked', allChecked); // Sync "All solution" checkbox
    // });

    // // Uncheck All if removed from selected list
    // $(document).on('click', '.post-ajax-filter .region-selected', function() {
    //     $('#region-all').prop('checked', false); // Sync "All solution" checkbox
    // });

    // const allRegionsChecked = $('input[name="region"]').length === $('input[name="region"]:checked').length;
    // $('.post-ajax-filter #region-all').prop('checked', allRegionsChecked);

    // $(document).on('click', '.post-ajax-filter .lg-filter-region-reset', function() {
    //     $('#region-all').prop('checked', false); // Sync "All solution" checkbox
    //     $('input[name="region"]').prop('checked', false); // Uncheck all checkboxes with name="solution"
    //     $('.listing-filter-form').submit();
    // });


    // // Handle "All Content Types" checkbox
    // $('.post-ajax-filter #type-all').on('change', function() {
    //     if ($(this).is(':checked')) {
    //         $('input[name="type"]').prop('checked', true); // Check all checkboxes with name="type"
    //     } else {
    //         $('input[name="type"]').prop('checked', false); // Uncheck all checkboxes with name="type"
    //     }
    // });

    // // Handle individual checkboxes with name="newsletter"
    // $('.post-ajax-filter input[name="type"]').on('change', function() {
    //     const allChecked = $('input[name="type"]:checked').length === $('input[name="type"]').length;
    //     $('.post-ajax-filter #type-all').prop('checked', allChecked); // Sync "All Types" checkbox
    // });

    // // Uncheck All if removed from selected list
    // $(document).on('click', '.type-selected', function() {
    //     $('.post-ajax-filter #type-all').prop('checked', false); // Sync "All solution" checkbox
    // });

    // const allTypeChecked = $('input[name="type"]').length === $('input[name="type"]:checked').length;
    // $('.post-ajax-filter #type-all').prop('checked', allTypeChecked);

    // $(document).on('click', '.post-ajax-filter .lg-filter-type-reset', function() {
    //     $('.post-ajax-filter #type-all').prop('checked', false); // Sync "All type" checkbox
    //     $('.post-ajax-filter input[name="type"]').prop('checked', false); // Uncheck all checkboxes with name="type"
    //     $('.post-ajax-filter .listing-filter-form').submit();
    // });

});

// Reset filter
$('.post-ajax-filter .reset-filter').click(function(e) {
    e.preventDefault();

    // Reset the 'paged' input to 1 (default page)
    $('.post-ajax-filter form.listing-filter-form #pager').val(1);
    $('.post-ajax-filter .listing-filter-form input[name="search_text"]').val('');
    $('.post-ajax-filter .listing-filter-form select[name="filter_order"] option:first').prop('selected', true);
    $('.post-ajax-filter .listing-filter-form input[type="checkbox"]').prop('checked', false);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

// Category filter
$('.post-ajax-filter form.listing-filter-form .filter-order,.post-ajax-filter form.listing-filter-form .cat-filter').change(function() {
    $('.post-ajax-filter form.listing-filter-form #pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});
$('.post-ajax-filter form.listing-filter-form .lg-filter-apply').click(function() {
    $('.post-ajax-filter form.listing-filter-form #pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

function post_filter_data(pager, posts_per_page, search_keyword, sort_value, region, lg_region_select, solution, lg_solution_select, type, lg_type_select, channel, lg_channel_select) {

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url, // Ensure correct variable name
        data: {
            action: 'fetch_post_list',
            security: filter_obj.nonce, // Pass the nonce
            pager: pager,
            posts_per_page: posts_per_page,
            search_keyword: search_keyword,
            solution: solution,
            lg_solution_select: lg_solution_select,
            region: region,
            lg_region_select: lg_region_select,
            channel: channel,
            lg_channel_select: lg_channel_select,
            type: type,
            lg_type_select: lg_type_select,
            sort_value: sort_value,
        },
        beforeSend: function() {
            $('.filter-load-more').show();
            $('.pagination').hide();
            $('.lg-grid-main-row').hide();
        },
        success: function(response) {
            $('.filter-load-more').hide();
            $('.lg-grid-main-row').html(response.data).hide().show();
            $('.pagination').show();
            $('.pagination').html(response.pagination);

            $('html, body').animate({
                scrollTop: $('.post-ajax-filter').position().top - 60,
            }, 1000);

            if (response.total_pages) {
                $('.post-ajax-filter form.listing-filter-form input[name="max_pages"]').val(response.total_pages);
            }

            if (response.pager) {
                $('.post-ajax-filter form.listing-filter-form #pager').val(response.pager);
            }

            if (response.showing) {
                $('.post-ajax-filter form.listing-filter-form .showing-result').text(response.showing);
            }
            const currentPageUrl = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();

            $('.post-ajax-filter .pagination a.page-numbers:not(.prev,.next)').each(function() {
                const pageNumber = parseInt($(this).text());
                $(this).attr('href', currentPageUrl + '?pager=' + pageNumber);
            });

            $('.post-ajax-filter .pagination a.page-numbers.prev:not(.disabled)').each(function() {
                const previousPage = response.pager - 1;
                $(this).attr('href', currentPageUrl + '?pager=' + previousPage);
            });

            $('.post-ajax-filter .pagination a.page-numbers.next:not(.disabled)').each(function() {
                const nextPage = parseInt(response.pager, 10) + 1;
                $(this).attr('href', currentPageUrl + '?pager=' + nextPage);
            });


        },
        error: function(error) {
            /* eslint-disable no-console */
            console.log('AJAX error:', error);
            /* eslint-enable no-console */
        },
    });
}

// function modify_post_filter_url(pager, search_keyword, sort_value, region, solution, type) {

//     let query_string = '';
//     const current_page_url = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
//     query_string += 'pager=' + pager;


//     if (solution !== '' && typeof solution !== 'undefined') {
//         query_string += '&solution=' + solution;
//     }

//     if (region !== '' && typeof region !== 'undefined') {
//         query_string += '&region=' + region;
//     }

//     if (type !== '' && typeof type !== 'undefined') {
//         query_string += '&type=' + type;
//     }

//     if (search_keyword !== '' && typeof search_keyword !== 'undefined') {
//         query_string += '&search_text=' + search_keyword;
//     }

//     if (sort_value !== '' && typeof sort_value !== 'undefined') {
//         query_string += '&filter_order=' + sort_value;
//     }
//     // Determine if a separator is needed
//     const separator = current_page_url.includes('?') ? '&' : '?';
//     const updated_url = current_page_url + '' + separator + query_string;

//     // Update the browser URL without refreshing the page
//     history.pushState(null, null, updated_url);

//     // Update the canonical link in the head section
//     let canonicalLink = document.querySelector('link[rel="canonical"]');

//     // If a canonical link exists, update its href attribute, otherwise, create a new one
//     if (canonicalLink) {
//         canonicalLink.setAttribute('href', updated_url);
//     } else {
//         canonicalLink = document.createElement('link');
//         canonicalLink.setAttribute('rel', 'canonical');
//         canonicalLink.setAttribute('href', updated_url);
//         document.head.appendChild(canonicalLink);
//     }
// }
